//#region DevExpress Imports

import 'devextreme/ui/load_indicator'
import 'devextreme/ui/button'
import 'devextreme/ui/select_box'

//#endregion

import { $COMPILE_SERVICE_NAME, $ELEMENT_SERVICE_NAME, $Q_SERVICE_NAME, $SCOPE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'
import { USER_SESSION_SERVICE_NAME } from '../../../services/user-session'
import { GridDetailsController } from './grid-details.directive.controller'
import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../common.module'
import { IUserSession } from '../../../helpers/user-session'
import { GridDetailsService, GRID_DETAILS_SERVICE_NAME } from './services'
import { GridService, GRID_SERVICE_NAME } from '../../../services/grid'
import { MeasurementsService } from '../measurements/measurements.service'

//#region Asset Imports

import './grid-details.scss'
import * as TEMPLATE from './grid-details.tpl.html'

//#endregion

export const DIRECTIVE_NAME = 'gridDetails'

export class GridDetailsDirective implements ng.IDirective {
    restrict = 'E'

    scope = {
        settings: '='
    }

    template = TEMPLATE

    link = (scope, element, attrs) => {
        scope.$watch("source", value => {
            scope.source = value
        })
    }

    controller = [
        $SCOPE_SERVICE_NAME,       
        $COMPILE_SERVICE_NAME,        
        USER_SESSION_SERVICE_NAME,
        GRID_DETAILS_SERVICE_NAME,
        GRID_SERVICE_NAME,
        'measurements',
        (
            $scope,            
            $compile: ng.ICompileService,            
            userSession: IUserSession,
            gridDetailsService: GridDetailsService,
            gridService: GridService,
            measurementService: MeasurementsService
        ) => { 
            return new GridDetailsController
                (
                    $scope,                    
                    $compile,
                    userSession,
                    gridDetailsService,
                    gridService,
                    measurementService
                )
        }]
}